import * as React from "react";
import ParametroTopo from "./topo";
import { ParametroDetalhe } from "./detalhe";
import { ParametroBottom } from "./bottom";
import Utils from "../../helper/utils";
import { useTranslation } from "react-i18next";

export const ParametroPage = () => {
  const { t } = useTranslation();

  Utils.setDocumentTitle(t("pages.parameters.title"));

  return (
    <React.Fragment>
      <ParametroDetalhe />
      <ParametroBottom />
    </React.Fragment>
  );
};
